import { render, staticRenderFns } from "./CoursewareToolbar.vue?vue&type=template&id=9b7b2ea0&"
import script from "./CoursewareToolbar.vue?vue&type=script&lang=js&"
export * from "./CoursewareToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports